import db from "@/database";

export const getLastConfig = () => {
  return db.config.orderBy("id").last();
};

export const getFilteredItems = () => {
  return db.filteredItems.toArray();
};
